module.exports = __webpack_public_path__ + "static/media/BeatSwapLightLogo.7d7a686a.png";